import { render, staticRenderFns } from "./EditVote.vue?vue&type=template&id=61b68c21"
import script from "./EditVote.vue?vue&type=script&lang=js"
export * from "./EditVote.vue?vue&type=script&lang=js"
import style0 from "./EditVote.vue?vue&type=style&index=0&id=61b68c21&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports